module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C593"
  }, [_c('span', {
    staticClass: "size_145"
  }, [_c('span', {
    staticClass: "color_0B0E11"
  }, [_c('strong', [_c('span', {
    attrs: {
      "id": "id_6"
    }
  }, [_vm._v("Color")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_vm._v("Color is fundamental to many design decisions and should be thought of at the beginning of the design process, not at the end. Too many colors can be confusing and messy, while the controlled use of color creates a unified and balanced design. Color provokes an emotional response and can provide direction for the design. I’ll discuss color in more detail in the next chapter.")])]), _vm._v(" "), _c('p', {
    staticClass: "C580"
  }, [_c('em', [_vm._v("Gray Play")]), _vm._v(" is an example of controlled color.")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/16_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C694"
  }, [_c('span', {
    staticClass: "size_85"
  }, [_c('em', [_vm._v("Gray Play")])]), _vm._v(" "), _c('span', {
    staticClass: "size_70"
  }, [_vm._v("("), _c('span', {
    attrs: {
      "href": "#/xhtml/28_Gray_Pla#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 80")]), _vm._v(")")])])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "C572"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "img/16_4.jpg"
    }
  }), _c('span', {
    staticClass: "size_85"
  }, [_c('em', [_vm._v("Intersections")])]), _vm._v(" "), _c('span', {
    staticClass: "size_90"
  }, [_vm._v("("), _c('span', {
    attrs: {
      "href": "#/xhtml/22_Intersec#page_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("page 40")]), _vm._v("), detail")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb5737b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/14___Color.vue
// module id = 93
// module chunks = 0